import { ApiConfigurationRule } from './types';
import instance from '@src/api/axiosInstance';

function getIntelligentCollectionConfigurations() {
  return instance.get('/v1/network_request/intelligent_collection');
}

function postIntelligentCollectionConfiguration(rule: Omit<ApiConfigurationRule, 'id'>) {
  const postPayload: any = {
    rule: rule.rule,
    req: rule.req,
  };
  
  if (rule.opt && rule.opt.cond && rule.opt.cond.length > 0) {
    postPayload.opt = rule.opt;
  }
  
  return instance.post('/v1/network_request/intelligent_collection', postPayload);
}

function putIntelligentCollectionConfiguration(rule: ApiConfigurationRule) {
  const putPayload: any = {
    rule: rule.rule,
    req: rule.req,
  };
  
  if (rule.opt && rule.opt.cond && rule.opt.cond.length > 0) {
    putPayload.opt = rule.opt;
  }
  
  return instance.put(`/v1/network_request/intelligent_collection/${rule.id}`, putPayload);
}

function deleteIntelligentCollectionConfiguration(ruleId: string) {
  return instance.delete(`/v1/network_request/intelligent_collection/${ruleId}`);
}

function reorderIntelligentCollectionConfigurations(ruleType: string, orderedIds: string[]) {
  return instance.put(`/v1/network_request/intelligent_collection/reorder`, { rule_type: ruleType, order: orderedIds });
}

export {
  getIntelligentCollectionConfigurations,
  postIntelligentCollectionConfiguration,
  putIntelligentCollectionConfiguration,
  deleteIntelligentCollectionConfiguration,
  reorderIntelligentCollectionConfigurations,
};